function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import cn from 'clsx';
import { bool, shape, string } from 'prop-types';
import Icon from '../../atoms/Icon/index.jsx';
import Image from '../../atoms/Image/index.jsx';

/**
 * Avatar component.
 */
var _ref = /*#__PURE__*/React.createElement(Icon, {
  color: "inherit",
  name: "person",
  size: 100,
  sizingUnit: "%"
});
const Avatar = ({
  className,
  image,
  noShadow
}) => /*#__PURE__*/React.createElement("div", {
  className: cn('avatar', className, noShadow && 'avatar--no-shadow')
}, image ? /*#__PURE__*/React.createElement(Image, _extends({}, image, {
  fluid: true
})) : _ref);
Avatar.defaultProps = {
  className: null,
  image: null,
  noShadow: false
};
Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**  Image properties */
  image: shape(Image.propTypes),
  /** Additional class names to add to the component root. */
  className: string,
  /** Show without the drop shadow. */
  noShadow: bool
} : {};
export default Avatar;